export class TemplateImageInspection {
    id = 0;
    description = '';
    tempUrl = '';
    fileName = '';
}
